<pr-form
  (onSubmit)="submit()"
  title="Modifier votre profil emprunteur"
  [formGroup]="form"
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
  clazz="drawer-form"
>
  <ng-container formArrayName="profilEmprunteurs">
    <pr-tabs
      clazz="drawer-tab-button"
      [defaultTextColor]="false"
      [changeTab]="changeTab"
      (lastTab)="onTabChange($event)"
    >
      @for (
        profilEmprunteur of profilEmprunteurs.controls;
        track profilEmprunteur;
        let index = $index
      ) {
        <pr-tab [label]="getUserName(profilEmprunteur.value.ownerId)">
          <ng-container [formGroup]="profilEmprunteur">
            <div class="form-sct-container">
              <pr-input-radio
                formControlName="fumeur"
                label="Est-ce que vous fumez ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="vapoteur"
                label="Est-ce que vous vapotez ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="vapoteurSansNicotine"
                label="Est-ce que vous vapotez sans nicotine ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input
                label="Est-ce que vous avez des déplacements kilométriques ?"
                [derrors]="derrors"
              >
                <mat-select formControlName="deplacementKilometrique">
                  @for (
                    deplacementKilometriqueOption of deplacementKilometriqueOptions;
                    track deplacementKilometriqueOption
                  ) {
                    <mat-option [value]="deplacementKilometriqueOption.id">
                      {{ deplacementKilometriqueOption.value }}
                    </mat-option>
                  }
                </mat-select>
              </pr-input>
              <pr-input
                label="Est-ce que vous effectuez un travail en hauteur ?"
                [derrors]="derrors"
              >
                <mat-select formControlName="travailEnHauteur">
                  @for (
                    travailEnHauteurOption of travailEnHauteurOptions;
                    track travailEnHauteurOption
                  ) {
                    <mat-option [value]="travailEnHauteurOption.id">
                      {{ travailEnHauteurOption.value }}
                    </mat-option>
                  }
                </mat-select>
              </pr-input>
              <pr-input-radio
                formControlName="travailManuel"
                label="Est-ce que vous exercez un travail manuel ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="travailManuelAvecOutillage"
                label="Est-ce que vous exercez un travail manuel avec outillage ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input
                label="Est-ce que vous effectuez un travail à risque ?"
                [derrors]="derrors"
              >
                <mat-select formControlName="travailARisque">
                  @for (
                    travailARisqueOption of travailARisqueOptions;
                    track travailARisqueOption
                  ) {
                    <mat-option [value]="travailARisqueOption.id">
                      {{ travailARisqueOption.value }}
                    </mat-option>
                  }
                </mat-select>
              </pr-input>
              <pr-input-radio
                formControlName="travailProduitsDangereux"
                label="Est-ce que vous exercez un travail manuel avec des produits dangereux ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="travailDebout"
                label="Est-ce que vous effectuez un travail en station debout ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="sportARisque"
                label="Est-ce que vous exercez un sport à risque ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="deplacementsProfessionnelsOuHumanitairesEtranger"
                label="Est-ce que vous effectuez des déplacements professionnels ou humanitaires à l’étranger ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="optionIPP"
                label="Est-ce que vous souhaitez souscrire à une assurance invalidité professionnelle et perte de revenus ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="optionDosPsy"
                label="Est-ce que vous souhaitez souscrire à une assurance dos et psychique ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
              <pr-input-radio
                formControlName="loiLemoine"
                label="Êtes-vous déjà couvert sur un ou plusieurs prêts immobiliers pour un montant supérieur ou égal à 200 000€ ?"
                toggleBgEmpty="true"
              >
              </pr-input-radio>
            </div>
          </ng-container>
        </pr-tab>
      }
    </pr-tabs>
  </ng-container>
</pr-form>
